import { useIntl } from "react-intl";
import I18nKey from "../translations/I18nKey";

import InventoryIcon from "../assets/Icons/InventoryIcon.svg";

import { LOCAL_STORAGE_KEY_ACCESS_TOKEN } from "../constants/constants";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { SellersProps } from "components/types";
import {
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import BootstrapTooltip from "components/ToolTips/BootstrapTooltip";
import { EXCEL_MEDIA_TYPE } from "components/Table/constants";

export const getAccessToken = () => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN) as string;
  checkTokenExpiry(token);
  return token;
};

export const checkTokenExpiry = (token: string) => {
  if(token){
  const parseToken = JSON.parse(atob(token.split(".")[1]));
  if (moment(parseToken.exp).valueOf() < moment().valueOf() / 1000) {
    localStorage.clear();
  }
}
};

export const PERFORMANCE_DASHBOARD_WIDGETS = () => {
  const intl = useIntl();

  return [
    {
      id: 1,
      text: intl.formatMessage({
        id: I18nKey.SALES_DASHBOARD,
      }),
    },
    {
      id: 2,
      text: intl.formatMessage({
        id: I18nKey.SALES_BREAKOUT,
      }),
    },
    {
      id: 3,
      text: intl.formatMessage({
        id: I18nKey.SIGNIFIANT_SALES_CHANGES,
      }),
    },

    {
      id: 4,
      text: intl.formatMessage({
        id: I18nKey.SHIPMENT_STATUS,
      }),
    },
    // {
    //   id: 5,
    //   text: intl.formatMessage({
    //     id: I18nKey.INVENTORY_POSITION,
    //   }),
    // },
    {
      id: 6,
      text: intl.formatMessage({
        id: I18nKey.ADVERTISING,
      }),
    },
    {
      id: 7,
      text: intl.formatMessage({
        id: I18nKey.SUMMARY_CHART,
      }),
    },
    {
      id: 8,
      text: intl.formatMessage({
        id: I18nKey.RANK_CHANGES,
      }),
    },
  ];
};

export const DASHBOARD_LIST_ITEMS = (activeIndex: string = "dashboard") => {
  const intl = useIntl();
  return [
    {
      id: 2,
      name: intl.formatMessage({
        id: I18nKey.INVENTORY,
      }),
      icon: InventoryIcon,
      open: false,
      hasItems: true,
      items: [
        {
          id: 1,
          name: intl.formatMessage({
            id: I18nKey.REPLENSISHMENT,
          }),
        },
        {
          id: 2,
          name: intl.formatMessage({
            id: I18nKey.FULFILLMENT_FEES,
          }),
        },
      ],
    },
  ];
};

export const SALES_BREAKOUT_AGGREGATION_OPTIONS = [
  {
    id: 1,
    key: "Week",
    value: "week",
  },
  {
    id: 2,
    key: "Month",
    value: "month",
  },
  {
    id: 3,
    key: "Day",
    value: "day",
  },
];

export const SALES_DASHBOARD_AGGREGATION_OPTIONS = [
  {
    id: 1,
    key: "Week",
    value: "week",
  },
  {
    id: 2,
    key: "Month",
    value: "month",
  },
];

export const ADVERTISING_AGGREGATION_OPTIONS = [
  {
    id: 1,
    key: "Week",
    value: "week",
  },
  {
    id: 2,
    key: "Month",
    value: "month",
  },
];

export const ADVERTISING_GROUPING_OPTIONS = [
  {
    id: 1,
    key: "asin",
    value: "asin",
  },
  {
    id: 2,
    key: "campaign",
    value: "campaign",
  },
];

export const RANK_CHANGES_AGGREGATION_OPTIONS = [
  {
    id: 1,
    key: "Week",
    value: "week",
  },
];

export const PROMOTION_TYPES = [
  {
    field: "7_DAY_DEAL",
    name: "7 Day Deal",
    color: "#C8E6C9",
  },
  {
    field: "COUPON",
    name: "Coupon",
    color: "#E1BEE7",
  },
  {
    field: "LIGHTNING_DEAL",
    name: "Lightning Deal",
    color: "#FFCCBC",
  },
  {
    field: "PRIME_EXCLUSIVE_DEAL",
    name: "Prime Exclusive Deal",
    color: "#BBDEFB",
  },
  {
    field: "PROMOTION_CODE",
    name: "Promotion Code",
    color: "#B2DFDB",
  },
];

export const CAMEL_CASE_TO_WORDS = (word: string) => {
  const text = word;
  const result = text.replace(/([A-Z])/g, " $1");
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

export const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`).slice(1);

export const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const mediumScreen = () => {
  const screen = useMediaQuery("(min-width:900px) and (max-width: 1600px)");
  return screen;
};

export const camelToCamelSpaces = (text: string) => {
  const result = text.replace(/([A-Z])/g, " $1");
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

export const snakeToCamelCase = (s: string) => {
  return camelToCamelSpaces(
    s.toLowerCase().replace(/(_\w)/g, (w) => w.toUpperCase().substr(1))
  );
};

export const TitleCase = (s: string) =>
  s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
    c ? c.toUpperCase() : " " + d.toUpperCase()
  );

export const DateFormat = (date: string) => moment(date).format("MMM DD, YYYY");
export const DateFormatForMonthAndDate = (date: string) =>
  moment(date).format("MMM D");
export const DateFormatYear = (date: string) => moment(date).format("YYYY");
export const DateFormatForMonth = (date: string) =>
  moment(date).format("MMM, YYYY");

export const camelToSnake = (str: string) => {
  return str.replace(/[A-Z]/g, (c) => {
    return "_" + c.toLowerCase();
  });
};

export const DEFAULT_TABLE_ROWS = [5, 10, 25, 50, 100, 200, 500];
export const InputOnlyNumber = (val: string) => {
  if (val.match(/^[0-9]*(\.\d{0,2})?$/)) {
    return true;
  }
  return false;
};

export const COLORS_SCALING = [{ id: 1, name: "Sales ($)", checked: false }];

export const exportExcel = (excelData: any[], fileName: string) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument. spreadsheetml. sheet ;charset=UTF-8";
  const fileExtension = ".xlsx";

  // const exportToExcel = async () => {
  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb: any = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};
export const COMPARE = (a: SellersProps, b: SellersProps) =>
  a?.name.localeCompare(b?.name);

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const customValueFormatterWithDecimal = (
  params: GridRenderCellParams,
  numberOfDecimals?: number
) => {
  const value = Number(params.value);

  if (isNaN(value)) {
    return params.value || `0`;
  }

  if (value < 0) {
    return `(${Math.abs(value)})`;
  }

  return value.toFixed(numberOfDecimals ? numberOfDecimals : 2);
};

export const valueFormatter = (value: any) => {
  if (!isNaN(value)) {
    if (value < 0) {
      const res = Intl.NumberFormat("en-US").format(
        (value?.toFixed(2) * 100) / 100
      );
      return `(${Math.abs(Number(res))})`;
    }
    return value;
  }
};

export const marketplaceIdsAndUrlDropdown = [
  {
    id: "ATVPDKIKX0DER",
    name: "US",
    sellerURL: "https://sellercentral.amazon.com",
    adUrl: "amazon.com",
  },
  {
    id: "A2EUQ1WTGCTBG2",
    name: "Canada",
    sellerURL: "https://sellercentral.amazon.ca",
    adUrl: "amazon.ca",
  },
  {
    id: "A1F83G8C2ARO7P",
    name: "UK",
    sellerURL: "https://sellercentral-europe.amazon.com",
    adUrl: "amazon.co.uk",
  },
  {
    id: "A2Q3Y263D00KWC",
    name: "Brazil",
    sellerURL: "https://sellercentral.amazon.com.br",
    adUrl: "amazon.com.br",
  },
  {
    id: "A1AM78C64UM0Y8",
    name: "Mexico",
    sellerURL: "https://sellercentral.amazon.com.mx",
    adUrl: "amazon.com.mx",
  },
  {
    id: "A2VIGQ35RCS4UG",
    name: "United Arab Emirates (U.A.E.)",
    sellerURL: "https://sellercentral.amazon.ae",
    adUrl: "amazon.ae",
  },
  {
    id: "A1PA6795UKMFR9",
    name: "Germany",
    sellerURL: "https://sellercentral-europe.amazon.com",
    adUrl: "amazon.de",
  },
  {
    id: "ARBP9OOSHTCHU",
    name: "Egypt",
    sellerURL: "https://sellercentral.amazon.eg",
    adUrl: "amazon.eg",
  },
  {
    id: "A1RKKUPIHCS9HS",
    name: "Spain",
    sellerURL: "https://sellercentral-europe.amazon.com",
    adUrl: "amazon.es",
  },
  {
    id: "A13V1IB3VIYZZH",
    name: "France",
    sellerURL: "https://sellercentral-europe.amazon.com",
    adUrl: "amazon.fr",
  },
  {
    id: "A21TJRUUN4KGV",
    name: "India",
    sellerURL: "https://sellercentral.amazon.in",
    adUrl: "amazon.in",
  },
  {
    id: "APJ6JRA9NG5V4",
    name: "Italy",
    sellerURL: "https://sellercentral-europe.amazon.com",
    adUrl: "amazon.it",
  },
  {
    id: "A1805IZSGTT6HS",
    name: "Netherlands",
    sellerURL: "https://sellercentral.amazon.nl",
    adUrl: "amazon.nl",
  },
  {
    id: "A1C3SOZRARQ6R3",
    name: "Poland",
    sellerURL: "https://sellercentral.amazon.pl",
    adUrl: "amazon.pl",
  },
  {
    id: "A17E79C6D8DWNP",
    name: "Saudi Arabia",
    sellerURL: "https://sellercentral.amazon.sa",
    adUrl: "amazon.sa",
  },
  {
    id: "A2NODRKZP88ZB9",
    name: "Sweden",
    sellerURL: "https://sellercentral.amazon.se",
    adUrl: "amazon.se",
  },
  {
    id: "A33AVAJ2PDY3EV",
    name: "Turkey",
    sellerURL: "https://sellercentral.amazon.com.tr",
    adUrl: "amazon.com.tr",
  },
  {
    id: "A19VAU5U5O7RUS",
    name: "Singapore",
    sellerURL: "https://sellercentral.amazon.sg",
    adUrl: "amazon.sg",
  },
  {
    id: "A39IBJ37TRP1C6",
    name: "Australia",
    sellerURL: "https://sellercentral.amazon.com.au",
    adUrl: "amazon.com.au",
  },
  {
    id: "A1VC38T7YXB528",
    name: "Japan",
    sellerURL: "https://sellercentral.amazon.co.jp",
    adUrl: "amazon.co.jp",
  },
];

export const NUMBER_FORMAT = (
  params: GridRenderCellParams,
  decimal = false
) => {
  if (params.value) {
    if (Number(params.value)) {
      if (params.value < 0) {
        const val = params.value;
        return `(${Intl.NumberFormat("en-US").format(
          //@ts-ignore
          Math.abs(val).toFixed(decimal ? 1 : 0)
        )})`;
      } else {
        return Intl.NumberFormat("en-US").format(
          params.value?.toFixed(decimal ? 1 : 0)
        );
      }
    } else return 0;
  } else return params.value;
};
// params.value ? (
//   <span>{Intl.NumberFormat("en-US").format(params.value.toFixed(0))}</span>
// ) : (
//   Intl.NumberFormat("en-US").format(params.value)
// );

export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailRegex.test(email);
};

export const PAYMENTS_AGGREGATION_OPTIONS = [
  {
    id: 1,
    key: "ASIN",
    value: "asin",
  },
  // {
  //   id: 2,
  //   key: "Sku",
  //   value: "sku",
  // },
  {
    id: 3,
    key: "Brand",
    value: "brand",
  },
  {
    id: 4,
    key: "Product Type",
    value: "product_type",
  },
];

export const toSentenceCase = (camelCase: string) => {
  if (camelCase) {
    const result = camelCase.replace(/([A-Z])/g, " $1");
    return result[0].toUpperCase() + result.substring(1).toUpperCase();
  }
  return "";
};

export const roleType = [
  { id: 1, role: "Company Admin" },
  { id: 3, role: "Seller Operator" },
];

export const countries = [
  {
    code: "US",
    label: "United States",
    phone: "+1",
    suggested: true,
  },
  { code: "AD", label: "Andorra", phone: "+376" },
  {
    code: "AE",
    label: "United Arab Emirates",
    phone: "+971",
  },
  { code: "AF", label: "Afghanistan", phone: "+93" },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    phone: "+1-268",
  },
  { code: "AI", label: "Anguilla", phone: "+1-264" },
  { code: "AL", label: "Albania", phone: "+355" },
  { code: "AM", label: "Armenia", phone: "+374" },
  { code: "AO", label: "Angola", phone: "+244" },
  { code: "AQ", label: "Antarctica", phone: "+672" },
  { code: "AR", label: "Argentina", phone: "+54" },
  { code: "AS", label: "American Samoa", phone: "+1-684" },
  { code: "AT", label: "Austria", phone: "+43" },
  {
    code: "AU",
    label: "Australia",
    phone: "+61",
    suggested: true,
  },
  { code: "AW", label: "Aruba", phone: "+297" },
  { code: "AX", label: "Alland Islands", phone: "+358" },
  { code: "AZ", label: "Azerbaijan", phone: "+994" },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    phone: "+387",
  },
  { code: "BB", label: "Barbados", phone: "+1-246" },
  { code: "BD", label: "Bangladesh", phone: "+880" },
  { code: "BE", label: "Belgium", phone: "+32" },
  { code: "BF", label: "Burkina Faso", phone: "+226" },
  { code: "BG", label: "Bulgaria", phone: "+359" },
  { code: "BH", label: "Bahrain", phone: "+973" },
  { code: "BI", label: "Burundi", phone: "+257" },
  { code: "BJ", label: "Benin", phone: "+229" },
  { code: "BL", label: "Saint Barthelemy", phone: "+590" },
  { code: "BM", label: "Bermuda", phone: "+1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "+673" },
  { code: "BO", label: "Bolivia", phone: "+591" },
  { code: "BR", label: "Brazil", phone: "+55" },
  { code: "BS", label: "Bahamas", phone: "+1-242" },
  { code: "BT", label: "Bhutan", phone: "+975" },
  { code: "BV", label: "Bouvet Island", phone: "+47" },
  { code: "BW", label: "Botswana", phone: "+267" },
  { code: "BY", label: "Belarus", phone: "+375" },
  { code: "BZ", label: "Belize", phone: "+501" },
  {
    code: "CA",
    label: "Canada",
    phone: "+1",
    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    phone: "+61",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    phone: "+243",
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "+236",
  },
  {
    code: "CG",
    label: "Congo, Republic of the",
    phone: "+242",
  },
  { code: "CH", label: "Switzerland", phone: "+41" },
  { code: "CI", label: "Cote d'Ivoire", phone: "+225" },
  { code: "CK", label: "Cook Islands", phone: "+682" },
  { code: "CL", label: "Chile", phone: "+56" },
  { code: "CM", label: "Cameroon", phone: "+237" },
  { code: "CN", label: "China", phone: "+86" },
  { code: "CO", label: "Colombia", phone: "+57" },
  { code: "CR", label: "Costa Rica", phone: "+506" },
  { code: "CU", label: "Cuba", phone: "+53" },
  { code: "CV", label: "Cape Verde", phone: "+238" },
  { code: "CW", label: "Curacao", phone: "+599" },
  { code: "CX", label: "Christmas Island", phone: "+61" },
  { code: "CY", label: "Cyprus", phone: "+357" },
  { code: "CZ", label: "Czech Republic", phone: "+420" },
  {
    code: "DE",
    label: "Germany",
    phone: "+49",
    suggested: true,
  },
  { code: "DJ", label: "Djibouti", phone: "+253" },
  { code: "DK", label: "Denmark", phone: "+45" },
  { code: "DM", label: "Dominica", phone: "+1-767" },
  {
    code: "DO",
    label: "Dominican Republic",
    phone: "+1-809",
  },
  { code: "DZ", label: "Algeria", phone: "+213" },
  { code: "EC", label: "Ecuador", phone: "+593" },
  { code: "EE", label: "Estonia", phone: "+372" },
  { code: "EG", label: "Egypt", phone: "+20" },
  { code: "EH", label: "Western Sahara", phone: "+212" },
  { code: "ER", label: "Eritrea", phone: "+291" },
  { code: "ES", label: "Spain", phone: "+34" },
  { code: "ET", label: "Ethiopia", phone: "+251" },
  { code: "FI", label: "Finland", phone: "+358" },
  { code: "FJ", label: "Fiji", phone: "+679" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "+500",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "+691",
  },
  { code: "FO", label: "Faroe Islands", phone: "+298" },
  {
    code: "FR",
    label: "France",
    phone: "+33",
    suggested: true,
  },
  { code: "GA", label: "Gabon", phone: "+241" },
  { code: "GB", label: "United Kingdom", phone: "+44" },
  { code: "GD", label: "Grenada", phone: "+1-473" },
  { code: "GE", label: "Georgia", phone: "+995" },
  { code: "GF", label: "French Guiana", phone: "+594" },
  { code: "GG", label: "Guernsey", phone: "+44" },
  { code: "GH", label: "Ghana", phone: "+233" },
  { code: "GI", label: "Gibraltar", phone: "+350" },
  { code: "GL", label: "Greenland", phone: "+299" },
  { code: "GM", label: "Gambia", phone: "+220" },
  { code: "GN", label: "Guinea", phone: "+224" },
  { code: "GP", label: "Guadeloupe", phone: "+590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "+240" },
  { code: "GR", label: "Greece", phone: "+30" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "+500",
  },
  { code: "GT", label: "Guatemala", phone: "+502" },
  { code: "GU", label: "Guam", phone: "+1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "+245" },
  { code: "GY", label: "Guyana", phone: "+592" },
  { code: "HK", label: "Hong Kong", phone: "+852" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "+672",
  },
  { code: "HN", label: "Honduras", phone: "+504" },
  { code: "HR", label: "Croatia", phone: "+385" },
  { code: "HT", label: "Haiti", phone: "+509" },
  { code: "HU", label: "Hungary", phone: "+36" },
  { code: "ID", label: "Indonesia", phone: "+62" },
  { code: "IE", label: "Ireland", phone: "+353" },
  { code: "IL", label: "Israel", phone: "+972" },
  { code: "IM", label: "Isle of Man", phone: "+44" },
  { code: "IN", label: "India", phone: "+91" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "+246",
  },
  { code: "IQ", label: "Iraq", phone: "+964" },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    phone: "+98",
  },
  { code: "IS", label: "Iceland", phone: "+354" },
  { code: "IT", label: "Italy", phone: "+39" },
  { code: "JE", label: "Jersey", phone: "+44" },
  { code: "JM", label: "Jamaica", phone: "+1-876" },
  { code: "JO", label: "Jordan", phone: "+962" },
  {
    code: "JP",
    label: "Japan",
    phone: "+81",
    suggested: true,
  },
  { code: "KE", label: "Kenya", phone: "+254" },
  { code: "KG", label: "Kyrgyzstan", phone: "+996" },
  { code: "KH", label: "Cambodia", phone: "+855" },
  { code: "KI", label: "Kiribati", phone: "+686" },
  { code: "KM", label: "Comoros", phone: "+269" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "+1-869",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "+850",
  },
  { code: "KR", label: "Korea, Republic of", phone: "+82" },
  { code: "KW", label: "Kuwait", phone: "+965" },
  { code: "KY", label: "Cayman Islands", phone: "+1-345" },
  { code: "KZ", label: "Kazakhstan", phone: "+7" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "+856",
  },
  { code: "LB", label: "Lebanon", phone: "+961" },
  { code: "LC", label: "Saint Lucia", phone: "+1-758" },
  { code: "LI", label: "Liechtenstein", phone: "+423" },
  { code: "LK", label: "Sri Lanka", phone: "+94" },
  { code: "LR", label: "Liberia", phone: "+231" },
  { code: "LS", label: "Lesotho", phone: "+266" },
  { code: "LT", label: "Lithuania", phone: "+370" },
  { code: "LU", label: "Luxembourg", phone: "+352" },
  { code: "LV", label: "Latvia", phone: "+371" },
  { code: "LY", label: "Libya", phone: "+218" },
  { code: "MA", label: "Morocco", phone: "+212" },
  { code: "MC", label: "Monaco", phone: "+377" },
  {
    code: "MD",
    label: "Moldova, Republic of",
    phone: "+373",
  },
  { code: "ME", label: "Montenegro", phone: "+382" },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    phone: "+590",
  },
  { code: "MG", label: "Madagascar", phone: "+261" },
  { code: "MH", label: "Marshall Islands", phone: "+692" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "+389",
  },
  { code: "ML", label: "Mali", phone: "+223" },
  { code: "MM", label: "Myanmar", phone: "+95" },
  { code: "MN", label: "Mongolia", phone: "+976" },
  { code: "MO", label: "Macao", phone: "+853" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "+1-670",
  },
  { code: "MQ", label: "Martinique", phone: "+596" },
  { code: "MR", label: "Mauritania", phone: "+222" },
  { code: "MS", label: "Montserrat", phone: "+1-664" },
  { code: "MT", label: "Malta", phone: "+356" },
  { code: "MU", label: "Mauritius", phone: "+230" },
  { code: "MV", label: "Maldives", phone: "+960" },
  { code: "MW", label: "Malawi", phone: "+265" },
  { code: "MX", label: "Mexico", phone: "+52" },
  { code: "MY", label: "Malaysia", phone: "+60" },
  { code: "MZ", label: "Mozambique", phone: "+258" },
  { code: "NA", label: "Namibia", phone: "+264" },
  { code: "NC", label: "New Caledonia", phone: "+687" },
  { code: "NE", label: "Niger", phone: "+227" },
  { code: "NF", label: "Norfolk Island", phone: "+672" },
  { code: "NG", label: "Nigeria", phone: "+234" },
  { code: "NI", label: "Nicaragua", phone: "+505" },
  { code: "NL", label: "Netherlands", phone: "+31" },
  { code: "NO", label: "Norway", phone: "+47" },
  { code: "NP", label: "Nepal", phone: "+977" },
  { code: "NR", label: "Nauru", phone: "+674" },
  { code: "NU", label: "Niue", phone: "+683" },
  { code: "NZ", label: "New Zealand", phone: "+64" },
  { code: "OM", label: "Oman", phone: "+968" },
  { code: "PA", label: "Panama", phone: "+507" },
  { code: "PE", label: "Peru", phone: "+51" },
  { code: "PF", label: "French Polynesia", phone: "+689" },
  { code: "PG", label: "Papua New Guinea", phone: "+675" },
  { code: "PH", label: "Philippines", phone: "+63" },
  { code: "PK", label: "Pakistan", phone: "+92" },
  { code: "PL", label: "Poland", phone: "+48" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "+508",
  },
  { code: "PN", label: "Pitcairn", phone: "+870" },
  { code: "PR", label: "Puerto Rico", phone: "+1" },
  {
    code: "PS",
    label: "Palestine, State of",
    phone: "+970",
  },
  { code: "PT", label: "Portugal", phone: "+351" },
  { code: "PW", label: "Palau", phone: "+680" },
  { code: "PY", label: "Paraguay", phone: "+595" },
  { code: "QA", label: "Qatar", phone: "+974" },
  { code: "RE", label: "Reunion", phone: "+262" },
  { code: "RO", label: "Romania", phone: "+40" },
  { code: "RS", label: "Serbia", phone: "+381" },
  { code: "RU", label: "Russian Federation", phone: "+7" },
  { code: "RW", label: "Rwanda", phone: "+250" },
  { code: "SA", label: "Saudi Arabia", phone: "+966" },
  { code: "SB", label: "Solomon Islands", phone: "+677" },
  { code: "SC", label: "Seychelles", phone: "+248" },
  { code: "SD", label: "Sudan", phone: "+249" },
  { code: "SE", label: "Sweden", phone: "+46" },
  { code: "SG", label: "Singapore", phone: "+65" },
  { code: "SH", label: "Saint Helena", phone: "+290" },
  { code: "SI", label: "Slovenia", phone: "+386" },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
    phone: "+47",
  },
  { code: "SK", label: "Slovakia", phone: "+421" },
  { code: "SL", label: "Sierra Leone", phone: "+232" },
  { code: "SM", label: "San Marino", phone: "+378" },
  { code: "SN", label: "Senegal", phone: "+221" },
  { code: "SO", label: "Somalia", phone: "+252" },
  { code: "SR", label: "Suriname", phone: "+597" },
  { code: "SS", label: "South Sudan", phone: "+211" },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    phone: "+239",
  },
  { code: "SV", label: "El Salvador", phone: "+503" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "+1-721",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
    phone: "+963",
  },
  { code: "SZ", label: "Swaziland", phone: "+268" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "+1-649",
  },
  { code: "TD", label: "Chad", phone: "+235" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "+262",
  },
  { code: "TG", label: "Togo", phone: "+228" },
  { code: "TH", label: "Thailand", phone: "+66" },
  { code: "TJ", label: "Tajikistan", phone: "+992" },
  { code: "TK", label: "Tokelau", phone: "+690" },
  { code: "TL", label: "Timor-Leste", phone: "+670" },
  { code: "TM", label: "Turkmenistan", phone: "+993" },
  { code: "TN", label: "Tunisia", phone: "+216" },
  { code: "TO", label: "Tonga", phone: "+676" },
  { code: "TR", label: "Turkey", phone: "+90" },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    phone: "+1-868",
  },
  { code: "TV", label: "Tuvalu", phone: "+688" },
  {
    code: "TW",
    label: "Taiwan, Province of China",
    phone: "+886",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "+255",
  },
  { code: "UA", label: "Ukraine", phone: "+380" },
  { code: "UG", label: "Uganda", phone: "+256" },
  // {
  //   code: 'US',
  //   label: 'United States',
  //   phone: '+1',
  //   suggested: true,
  // },
  { code: "UY", label: "Uruguay", phone: "+598" },
  { code: "UZ", label: "Uzbekistan", phone: "+998" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "+379",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "+1-784",
  },
  { code: "VE", label: "Venezuela", phone: "+58" },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "+1-284",
  },
  {
    code: "VI",
    label: "US Virgin Islands",
    phone: "+1-340",
  },
  { code: "VN", label: "Vietnam", phone: "+84" },
  { code: "VU", label: "Vanuatu", phone: "+678" },
  { code: "WF", label: "Wallis and Futuna", phone: "+681" },
  { code: "WS", label: "Samoa", phone: "+685" },
  { code: "XK", label: "Kosovo", phone: "+383" },
  { code: "YE", label: "Yemen", phone: "+967" },
  { code: "YT", label: "Mayotte", phone: "+262" },
  { code: "ZA", label: "South Africa", phone: "+27" },
  { code: "ZM", label: "Zambia", phone: "+260" },
  { code: "ZW", label: "Zimbabwe", phone: "+263" },
];

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const snakeCaseToWords = (s: string) =>
  s.replace(/_/g, " ").replace(/\w\S*/g, function (word) {
    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
  });

export const emailValidationRegExp = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";

export const convertData = (data: any[], keys: string[]) => {
  const tempData: any[] = [];
  data.map((item) => {
    let temp: any = {};
    keys.map((element: any) => {
      let arr = element.split(".");
      temp.id = item.id;
      if (arr.length === 2) temp[arr[1]] = item[arr[0]][arr[1]];
      else if (arr.length === 3) temp[arr[2]] = item[arr[0]][arr[1]][arr[2]];
      else temp[arr[0]] = item[arr[0]];
    });
    tempData.push(temp);
  });
  return tempData;
};

export const downloadFileAsXlxs = (res: any, fileName: string) => {
  const link = document.createElement("a");
  link.href = EXCEL_MEDIA_TYPE + res;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function numberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
